import type {
  EditorSDK,
  Logger,
  DataSettingsManager,
} from '@wix/wix-data-client-common-standalone'
import { getErrorMessage } from './utils'

const logErrorMessage = (logger: Logger, error: unknown) => {
  const message = getErrorMessage(error)
  if (message === 'Unable to fetch result (Failed to fetch)') {
    logger.info(message)
  } else {
    logger.error(new Error('Data mode error', { cause: error }))
  }
  return message
}

export const updateDataModeValues = ({
  dataMode,
  editorSdkProxy,
  logger,
}: {
  dataMode: boolean
  editorSdkProxy: EditorSDK
  logger: Logger
}) => {
  logger.updateContext({ tags: { dataMode } })
  return editorSdkProxy.editor.updateAppState({
    dataMode,
  })
}

export const enableDataMode = async ({
  dataSettingsManager,
  logger,
}: {
  dataSettingsManager: DataSettingsManager
  logger: Logger
}) => {
  logger.breadcrumb({
    category: 'dataMode',
    message: 'Attempting to enable',
  })
  try {
    await dataSettingsManager.updateDataSettings({
      contentManagerEnabled: true,
    })
  } catch (error) {
    logErrorMessage(logger, error)
  }
}

export const initializeDataSettings = async ({
  dataSettingsManager,
  logger,
}: {
  dataSettingsManager: DataSettingsManager
  logger: Logger
}) => {
  try {
    logger.breadcrumb({
      category: 'dataMode',
      message: 'Attempting to read',
    })
    await dataSettingsManager.initialize()
  } catch (error) {
    logErrorMessage(logger, error)
  }
}

export const isDataModeEnabled = (dataSettingsManager: DataSettingsManager) =>
  dataSettingsManager.getDataSettings().contentManagerEnabled
